// La page d'UNE publication — ouverte depuis une notification, un lien partagé,
// ou le compteur de commentaires d'un reel.
//
// Elle ouvre les commentaires d'emblée : on n'arrive jamais ici par hasard. Ou
// bien quelqu'un a commenté chez vous, ou bien on vous a envoyé le lien — dans
// les deux cas, ce qui se dit sous la publication fait partie de ce qu'on vient
// voir.

import { useEffect, useState } from "react";
import Store from "../../store.js";
import Icone from "../Icone.jsx";
import Publication from "../Publication.jsx";
import Vide, { Chargement } from "../Vide.jsx";

export default function PagePublication({ ctx, params }) {
  const [etat, setEtat] = useState({ phase: "chargement" });

  useEffect(() => {
    let vivant = true;
    setEtat({ phase: "chargement" });
    Store.posts
      .get(params.id)
      .then((p) => vivant && setEtat(p ? { phase: "prete", p } : { phase: "introuvable" }))
      .catch(() => vivant && setEtat({ phase: "introuvable" }));
    return () => {
      vivant = false;
    };
  }, [params.id]);

  if (etat.phase === "chargement")
    return (
      <div className="colonne">
        <Chargement />
      </div>
    );

  if (etat.phase === "introuvable")
    return (
      <div className="colonne">
        <Vide symbole="🕊️" titre="Publication introuvable" texte="Elle a peut-être été supprimée." />
      </div>
    );

  return (
    <div className="colonne">
      <div className="entete-page">
        <a className="icon-btn" href="#/fil" aria-label="Retour">
          <Icone nom="retour" taille={20} />
        </a>
        <h1 className="titre-page">Publication</h1>
      </div>
      <div className="liste-posts">
        <Publication p={etat.p} ctx={ctx} commentairesDesLeDepart />
      </div>
    </div>
  );
}
